import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../models'

import type * as ec from './ec'
import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    bootstrap: store.actions.standalone({
      // omit schemaFeature, since it will be provided by the feature
      data: store.actions.Data.asIs<
        Omit<ec.Config, 'schemaFeature' | 'meFeature'>
      >(),
    }),
    dispose: store.actions.standalone({
      data: ({
        all,
        ref,
      }: ExactlyOneOf<{
        /**
         * When provided, includes all dynamically bootstrapped
         * {@link ec.Collection} in the operation. This is useful when you want
         * to apply an action to the entire set of dynamic {@link ec.Collection}
         * without filtering or specifying individual references.
         */
        readonly all: true
        /**
         * This allows targeting only {@link ec.Collection} created through the
         * {@link models.widget.Ref}.
         *
         * @see {@link models.widget.Ref} for details on the reference mechanism
         * @example
         * // Target only ECs created with a specific widget reference
         * const specificComponents = { ref: myWidgetRef };
         */
        readonly ref: models.widget.Ref
      }>) => ({
        all,
        ref,
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
